export {TsVideoPlayerPopup} from './component';
export type {TsVideoPlayerPopupProps} from './component';
